import axiosInstance, { TokenManager } from "./utils/axiosConfig";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const { NODE_ENV, REACT_APP_API_URL } = process.env;

function Logout() {
    const history = useHistory();
    
    useEffect(async () => {
        const result = await axiosInstance.post("/auth/logout").then((result) => {
            TokenManager.clearToken();
            window.localStorage.removeItem("USER");
            window.localStorage.removeItem("CHILDREN");
            window.localStorage.removeItem("SETTINGS");
            window.localStorage.removeItem("SELECTED_CHILD_ID")
            
            if (NODE_ENV === "development") {
                window.location.href = "http://localhost:3000/";
            } else if (NODE_ENV === "staging") {
                window.location.href = "https://staging.bridgepalkids.com/";
            } else {
                window.location.href = "https://www.bridgepalkids.com/"; // Redirect user back to the Wix website.
            }
        });
        
        // If the axios request fails, redirect the user back to the Wix website.
        if (result.status !== 200) {
            console.error("Logout failed!");
            console.error(`Logout::Logout() failed! Status: ${result.status} - ${result.statusText}`);
            window.location.href = "https://www.bridgepalkids.com/";
        }
    }, []);
    
    return <div />;
}

export default Logout;
